import React, { useEffect, useMemo, useState } from "react";
import { database } from "../services/firebase";
import { ref, get } from "firebase/database";

const PremiumContentViewer = ({ selectedPath, selectedTitle }) => {

  const [hasUserSelected, setHasUserSelected] = useState(false);
  const [ipcSections, setIPCSections] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [contentLoading, setContentLoading] = useState(false);
  const [contentError, setContentError] = useState("");

  useEffect(() => {
    if (!selectedPath) return;
      // 👇 mark user interaction
  setHasUserSelected(true);
    fetchQuestions();
  }, [selectedPath]);

  const stats = useMemo(() => {
    return {
      total: questions.length,
      withExplanation: questions.filter((q) => q.explanation).length,
      withAnswer: questions.filter((q) => q.answer).length
    };
  }, [questions]);




  const getRandomSubset = (array, limit = 200) => {
  const shuffled = [...array].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, limit);
};

 const fetchQuestions = async () => {
  try {
    setContentLoading(true);
    setContentError("");
    setOpenIndex(null);

    let dbPath = selectedPath;

// 🔥 Special handling for LAW
if (selectedPath === "lawipc") {
  dbPath = "ipc_sections";
}

const snapshot = await get(ref(database, dbPath));

    if (!snapshot.exists()) {
      setQuestions([]);
      setIPCSections([]);
      return;
    }

    const rawData = snapshot.val();

   let dataArray = [];

if (Array.isArray(rawData)) {
  // ✅ ROOT LEVEL ARRAY (your new format)
  dataArray = rawData;
} else if (rawData?.ipc_sections && Array.isArray(rawData.ipc_sections)) {
  dataArray = rawData.ipc_sections;
} else if (typeof rawData === "object") {
  dataArray = Object.values(rawData).flat();
}

    if (dataArray.length > 0) {

      // ✅ detect IPC properly
      const isIPC = dataArray.some(item => item?.section_number);

      if (isIPC) {
        setIPCSections(dataArray);
        setQuestions([]);
      } else {
        const filtered = dataArray.filter(isQuestionObject);
        const random200 = getRandomSubset(filtered, 200);
        setQuestions(random200);
        setIPCSections([]);
      }

    } else {
      setQuestions([]);
      setIPCSections([]);
    }

  } catch (error) {
    console.error("🔥 Content fetch error:", error);
    setQuestions([]);
    setIPCSections([]);
    setContentError(`Failed to load selected content: ${error.message}`);
  } finally {
    setContentLoading(false);
  }
};

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

return (
  <div>

    {!hasUserSelected && (
      <div className="text-center mt-5">
        <div
          style={{
            maxWidth: "700px",
            margin: "0 auto",
            padding: "40px",
            borderRadius: "24px",
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.08)"
          }}
        >
          <h3 style={{ color: "#f8fafc", fontWeight: 800 }}>
            📂 Select a Subject
          </h3>
          <p style={{ color: "#94a3b8", marginTop: "10px" }}>
            Choose any category from the sidebar to view content.
          </p>
        </div>
      </div>
    )}

   {hasUserSelected && (
  <>
    {contentError && (
          <div
            className="mb-4"
            style={{
              padding: "18px 20px",
              borderRadius: "18px",
              background: "rgba(239,68,68,0.12)",
              border: "1px solid rgba(239,68,68,0.22)",
              color: "#fecaca"
            }}
          >
            {contentError}
          </div>
        )}

        {contentLoading ? (
          <div className="text-center mt-5">
            <div
              className="spinner-border"
              role="status"
              style={{ width: "2.8rem", height: "2.8rem", color: "#38bdf8" }}
            ></div>
            <p className="mt-4 fw-semibold fs-6 fs-md-5" style={{ color: "#e2e8f0" }}>
              Loading premium questions...
            </p>
          </div>
        ) : questions.length === 0 && ipcSections.length === 0 ? (
          <div className="text-center mt-5">
            <div
              style={{
                maxWidth: "860px",
                margin: "0 auto",
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "24px",
                padding: "36px 24px",
                backdropFilter: "blur(16px)",
                boxShadow: "0 16px 40px rgba(0,0,0,0.28)"
              }}
            >
              <div
                style={{
                  width: "68px",
                  height: "68px",
                  margin: "0 auto 18px",
                  borderRadius: "20px",
                  background: "rgba(56,189,248,0.08)",
                  border: "1px solid rgba(56,189,248,0.14)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.9rem"
                }}
              >
                📂
              </div>

              <h3 className="fw-bold mb-3" style={{ color: "#f8fafc" }}>
                No questions found
              </h3>
              <p style={{ color: "#cbd5e1", marginBottom: 0, lineHeight: "1.85" }}>
                This node may contain only structure or subcategories.
                <br />
                Please click another subject or subcategory.
              </p>
            </div>
          </div>
        ) : (
        <>

        
          {/* TOP STATS */}
          <div className="mb-5">
            <div className="row g-3 g-md-4">
              <div className="col-12 col-md-4">
                <div style={statsCardStyle}>
                  <div style={statsIconStyle}>📚</div>
                  <div>
                    <div style={statsLabelStyle}>Total Questions</div>
                    <div style={statsValueStyle}>{stats.total}</div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div style={statsCardStyle}>
                  <div style={statsIconStyle}>✅</div>
                  <div>
                    <div style={statsLabelStyle}>With Answers</div>
                    <div style={statsValueStyle}>{stats.withAnswer}</div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div style={statsCardStyle}>
                  <div style={statsIconStyle}>📖</div>
                  <div>
                    <div style={statsLabelStyle}>With Explanations</div>
                    <div style={statsValueStyle}>{stats.withExplanation}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

{ipcSections.length > 0 &&
  renderIPCSections({
    ipc_sections: ipcSections,
    openIndex,
    toggleAnswer
  })}

          {/* QUESTION LIST */}
          <div className="d-flex flex-column gap-4">
            {questions.map((item, index) => (
              <div
                key={index}
                style={{
                  borderRadius: "26px",
                  background:
                    "linear-gradient(145deg, rgba(15,23,42,0.96), rgba(17,24,39,0.93))",
                  border: "1px solid rgba(255,255,255,0.07)",
                  boxShadow: "0 18px 45px rgba(0,0,0,0.28)",
                  overflow: "hidden"
                }}
              >
                <div style={{ padding: "22px 18px", paddingInline: "clamp(18px, 4vw, 28px)" }}>
                  {/* TOP BAR */}
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
                    <div
                      style={{
                        background: "rgba(56,189,248,0.12)",
                        border: "1px solid rgba(56,189,248,0.25)",
                        color: "#38bdf8",
                        padding: "8px 16px",
                        borderRadius: "999px",
                        fontWeight: "700",
                        fontSize: "13px"
                      }}
                    >
                      Question {index + 1}
                    </div>

                    <div className="d-flex flex-wrap gap-2">
                      <span style={badgePurpleStyle}>
                        {item.category || "UPSC"}
                      </span>

                      <span style={badgeGreenStyle}>
                        {item.subcategory || selectedTitle || "Premium"}
                      </span>
                    </div>
                  </div>

                  {/* QUESTION */}
                  <div className="mb-4">
                    <h3
                      style={{
                        fontSize: "clamp(1.05rem, 2vw, 1.28rem)",
                        lineHeight: "1.75",
                        fontWeight: "800",
                        fontFamily: "math",
                        color: "#f8fafc",
                        marginBottom: "0"
                      }}
                    >
                      {item.question || "No question text"}
                    </h3>
                  </div>

                  {/* META INFO */}
                  {(item.marks || item.word_limit || item.answer_type) && (
                    <div className="d-flex flex-wrap gap-2 mb-4">
                      {item.answer_type && (
                        <span style={badgeYellowStyle}>
                          Type: {item.answer_type}
                        </span>
                      )}

                      {item.marks && (
                        <span style={badgePinkStyle}>
                          Marks: {item.marks}
                        </span>
                      )}

                      {item.word_limit && (
                        <span style={badgeBlueStyle}>
                          Word Limit: {item.word_limit}
                        </span>
                      )}
                    </div>
                  )}

                  {/* ACTION BUTTON */}
                  <div className="mb-2">
                    <button
                      className="btn w-100 w-md-auto"
                      onClick={() => toggleAnswer(index)}
                      style={{
                        borderRadius: "16px",
                        padding: "13px 22px",
                        fontWeight: "800",
                        fontSize: "14px",
                        color: "#fff",
                        border: "none",
                        background:
                          openIndex === index
                            ? "linear-gradient(135deg, #ef4444, #dc2626)"
                            : "linear-gradient(135deg, #22c55e, #16a34a)",
                        boxShadow:
                          openIndex === index
                            ? "0 10px 22px rgba(239,68,68,0.28)"
                            : "0 10px 22px rgba(34,197,94,0.28)",
                        transition: "all 0.3s ease"
                      }}
                    >
                      {openIndex === index ? "Hide Answer" : "View Answer"}
                    </button>
                  </div>

                  {/* ANSWER SECTION */}
                  {openIndex === index && (
                    <div
                      style={{
                        marginTop: "22px",
                        borderRadius: "22px",
                        padding: "22px 18px",
                        background:
                          "linear-gradient(145deg, rgba(255,255,255,0.04), rgba(255,255,255,0.025))",
                        border: "1px solid rgba(255,255,255,0.07)"
                      }}
                    >
                      <div className="mb-4">
                        <h5
                          style={{
                            color: "#22c55e",
                            fontWeight: "800",
                            marginBottom: "12px"
                          }}
                        >
                          ✅ Correct Answer
                        </h5>

                        <div
                          style={{
                            fontSize: "1rem",
                            fontWeight: "700",
                            lineHeight: "1.85",
                            color: "#f8fafc",
                            background: "rgba(34,197,94,0.08)",
                            padding: "16px 18px",
                            borderRadius: "16px",
                            border: "1px solid rgba(34,197,94,0.15)"
                          }}
                        >
                          {item.answer || "No answer available"}
                        </div>
                      </div>

                      <div>
                        <h5
                          style={{
                            color: "#38bdf8",
                            fontWeight: "800",
                            marginBottom: "12px"
                          }}
                        >
                          📖 Explanation
                        </h5>

                        <div
                          style={{
                            color: "#cbd5e1",
                            fontSize: "0.98rem",
                            lineHeight: "1.9",
                            background: "rgba(56,189,248,0.06)",
                            padding: "18px",
                            borderRadius: "16px",
                            border: "1px solid rgba(56,189,248,0.12)"
                          }}
                        >
                          {item.explanation || "No explanation available"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>


        </>
      )}
      </>
   )}
    </div>

  );
};
















const isQuestionObject = (item) => {
  return (
    item &&
    typeof item === "object" &&
    ("question" in item || "answer" in item || "explanation" in item)
  );
};











const renderIPCSections = ({ ipc_sections, openIndex, toggleAnswer }) => {
  return (
    <div className="mt-5" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      {ipc_sections.map((item, index) => (
        <div
          key={index}
          style={{
            marginBottom: "20px",
            padding: "20px",
            borderRadius: "16px",
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.08)"
          }}
        >
          {/* HEADER */}
          <div
            onClick={() => toggleAnswer(index)}
            style={{ cursor: "pointer" }}
          >
            <h5 style={{ color: "#38bdf8" }}>
              ⚖️ IPC Section {item.section_number}: {item.section_title}
            </h5>
            <p style={{ color: "#94a3b8", marginBottom: "5px" }}>
              Chapter {item.chapter?.chapter_number || "N/A"} - {item.chapter?.chapter_name || "N/A"}
            </p>
          </div>

          {openIndex === index && (
  <div className="mt-4 d-flex flex-column gap-3">

    {/* GRID LAYOUT */}
    <div className="row g-3">

      {/* Bare Act */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>📜 Bare Act</h6>
          <p style={cardText}>{item.bare_act}</p>
        </div>
      </div>

      {/* Explanation */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>🧠 Explanation</h6>
          <p style={cardText}>{item.simple_explanation}</p>
        </div>
      </div>

      {/* Key Concepts */}
      <div className="col-md-6">
        <div style={modernCard}>
          <h6 style={cardTitle}>🔑 Key Concepts</h6>
          <ul style={listStyle}>
            {item.key_concepts?.map((k, i) => <li key={i}>{k}</li>)}
          </ul>
        </div>
      </div>

      {/* When Applied */}
      <div className="col-md-6">
        <div style={modernCard}>
          <h6 style={cardTitle}>📌 When Applied</h6>
          <ul style={listStyle}>
            {item.when_applied?.map((k, i) => <li key={i}>{k}</li>)}
          </ul>
        </div>
      </div>

      {/* Real Example */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>🌍 Real Example</h6>
          <p style={cardText}>{item.real_world_example}</p>
        </div>
      </div>

      {/* Legal Notes */}
      <div className="col-md-6">
        <div style={modernCard}>
          <h6 style={cardTitle}>⚖️ Legal Notes</h6>
          <ul style={listStyle}>
            {item.legal_notes?.map((k, i) => <li key={i}>{k}</li>)}
          </ul>
        </div>
      </div>

      {/* Practical Use */}
      <div className="col-md-6">
        <div style={modernCard}>
          <h6 style={cardTitle}>📊 Practical Use</h6>
          <ul style={listStyle}>
            {item.practical_application?.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
        </div>
      </div>

      {/* Constitutional Links */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>🏛 Constitutional Links</h6>
          <ul style={listStyle}>
            {item.constitutional_links?.map((c, i) => (
              <li key={i}>
                <strong>{c.article}</strong> — {c.title}
                <br />
                <span style={{ color: "#94a3b8" }}>{c.relevance}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Amendments */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>🛠 Amendments</h6>
          <ul style={listStyle}>
            {item.amendment_history?.map((a, i) => (
              <li key={i}>
                <strong>{a.year}</strong> — {a.change}
                <br />
                <span style={{ color: "#94a3b8" }}>{a.impact}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* UPSC Focus */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>🎯 UPSC Focus</h6>
          <ul style={listStyle}>
            <li><strong>Prelims:</strong> {item.upsc_focus?.prelims}</li>
            <li><strong>Mains:</strong> {item.upsc_focus?.mains}</li>
            <li><strong>Interview:</strong> {item.upsc_focus?.interview}</li>
          </ul>
        </div>
      </div>

      {/* Memory + Status */}
      <div className="col-md-6">
        <div style={modernCard}>
          <h6 style={cardTitle}>🧩 Memory Trick</h6>
          <p style={cardText}>{item.memory_trick}</p>
        </div>
      </div>

      <div className="col-md-6">
        <div style={modernCard}>
          <h6 style={cardTitle}>📌 Status</h6>
          <p style={cardText}>{item.status}</p>
        </div>
      </div>

      {/* Related */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>🔗 Related Sections</h6>
          <p style={cardText}>{item.related_sections?.join(", ")}</p>
        </div>
      </div>

      {/* Replace Info */}
      {item.replaced_by && (
        <div className="col-12">
          <div style={modernCard}>
            <h6 style={cardTitle}>🔄 Replaced By</h6>
            <p style={cardText}>
              {item.replaced_by.law} — {item.replaced_by.note}
            </p>
          </div>
        </div>
      )}

      {/* Last Updated */}
      <div className="col-12">
        <div style={modernCard}>
          <h6 style={cardTitle}>🕒 Last Updated</h6>
          <p style={cardText}>{item.last_updated}</p>
        </div>
      </div>

    </div>
  </div>
)}
        </div>
      ))}
    </div>
  );
};



const Block = ({ title, content }) => {
  if (!content) return null;
  return (
    <div style={innerCard}>
      <h5 style={titleStyle}>{title}</h5>
      <p style={{ color: "#cbd5e1", lineHeight: "1.8" }}>{content}</p>
    </div>
  );
};

const ListBlock = ({ title, items }) => {
  if (!items || !items.length) return null;
  return (
    <div style={innerCard}>
      <h5 style={titleStyle}>{title}</h5>
      <ul style={{ color: "#cbd5e1", paddingLeft: "18px" }}>
        {items.map((item, i) => (
          <li key={i} style={{ marginBottom: "6px" }}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

const innerCard = {
  background: "rgba(255,255,255,0.04)",
  padding: "16px",
  borderRadius: "16px",
  marginBottom: "14px",
  border: "1px solid rgba(255,255,255,0.06)"
};

const titleStyle = {
  color: "#38bdf8",
  fontWeight: 800,
  marginBottom: "8px"
};


const statsCardStyle = {
  borderRadius: "22px",
  padding: "20px",
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.92), rgba(17,24,39,0.88))",
  border: "1px solid rgba(255,255,255,0.08)",
  boxShadow: "0 12px 30px rgba(0,0,0,0.22)",
  display: "flex",
  alignItems: "center",
  gap: "16px",
  height: "100%"
};

const statsIconStyle = {
  width: "56px",
  height: "56px",
  borderRadius: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(56,189,248,0.12)",
  border: "1px solid rgba(56,189,248,0.18)",
  fontSize: "1.4rem",
  flexShrink: 0
};

const statsLabelStyle = {
  color: "#94a3b8",
  fontSize: "0.88rem",
  fontWeight: 700,
  marginBottom: "4px"
};

const statsValueStyle = {
  color: "#f8fafc",
  fontSize: "1.65rem",
  fontWeight: 900
};

const badgePurpleStyle = {
  background: "rgba(168,85,247,0.15)",
  color: "#e9d5ff",
  padding: "7px 14px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: "600",
  border: "1px solid rgba(168,85,247,0.2)"
};

const badgeGreenStyle = {
  background: "rgba(34,197,94,0.12)",
  color: "#bbf7d0",
  padding: "7px 14px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: "600",
  border: "1px solid rgba(34,197,94,0.2)"
};

const badgeYellowStyle = {
  background: "rgba(251,191,36,0.12)",
  color: "#fde68a",
  padding: "7px 12px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 700,
  border: "1px solid rgba(251,191,36,0.2)"
};

const badgePinkStyle = {
  background: "rgba(244,114,182,0.12)",
  color: "#f9a8d4",
  padding: "7px 12px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 700,
  border: "1px solid rgba(244,114,182,0.2)"
};

const badgeBlueStyle = {
  background: "rgba(99,102,241,0.12)",
  color: "#c7d2fe",
  padding: "7px 12px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 700,
  border: "1px solid rgba(99,102,241,0.2)"
};

const modernCard = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "18px",
  padding: "16px",
  backdropFilter: "blur(12px)",
  boxShadow: "0 8px 24px rgba(0,0,0,0.25)"
};

const cardTitle = {
  color: "#38bdf8",
  fontWeight: 800,
  marginBottom: "10px",
  fontSize: "0.95rem"
};

const cardText = {
  color: "#e2e8f0",
  lineHeight: "1.8",
  fontSize: "0.92rem"
};

const listStyle = {
  color: "#cbd5e1",
  paddingLeft: "18px",
  lineHeight: "1.8",
  fontSize: "0.9rem"
};

export default PremiumContentViewer;